require('./brokerTransferOfDerivatives.scss');

// @vendors
const React = require('react');
const moment = require('moment');
const PropTypes = require('prop-types');

// @components
const { AmountInput } = require('commonsComponents/amountInput');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { OKInput } = require('commonsComponents/OKInput');

// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @constants
const { DATE_FORMAT_COMPLETE } = require('constants/index');
const language = getLanguage();

class BrokerTransferOfDerivatives extends React.Component {
    constructor(props) {
        super(props);
        this.handleConceptChange = this.handleConceptChange.bind(this);
    }

    buildDerivativeTransferContent() {
        const {
            showCreationDate,
            creationDate,
            originAccountName,
            originAccountNumber,
            originAccountBalance,
            originAccountBalanceCurrency,
            destinationAccountName,
            destinationAccountNumber,
            destinationAccountBalance,
            destinationAccountBalanceCurrency
        } = this.props;

        const formatCreationDate = moment(creationDate).format(DATE_FORMAT_COMPLETE)

        const originAccountBalanceObject = {
            amount: originAccountBalance,
            currency: originAccountBalanceCurrency
        };

        const destinationAccountBalanceObject = {
            amount: destinationAccountBalance,
            currency: destinationAccountBalanceCurrency
        };
        const plainAmountOriginObject = getPlainAmountObject(originAccountBalanceObject);
        const plainAmountDestinationObject = getPlainAmountObject(destinationAccountBalanceObject);
        let creationDateSection;

        if (showCreationDate) {
            creationDateSection = (
                <OKInformativeList>
                    <OKInformativeListItem
                        title="broker-transferOfDerivativesCreationDate"
                        bodyText={formatCreationDate}
                        isUppercaseTitle={true}
                    />
                </OKInformativeList>
            );
        }

        return (
            <article>
                {creationDateSection}
                <OKInformativeList columns={2}>
                    <OKInformativeListItem
                        title="broker-transferOfDerivativesOriginAccount"
                        bodyText={originAccountName}
                        isUppercaseTitle={true}
                    >
                        {originAccountNumber}<br />
                        <FormattedText value="broker-transferOfDerivativesAvailableBalance" />
                        <OneLineSymbolAmount
                            amountObject={plainAmountOriginObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountOriginObject, true)} />
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title="broker-transferOfDerivativesDestinationAccount"
                        bodyText={destinationAccountName}
                        isUppercaseTitle={true}
                    >
                        {destinationAccountNumber}<br />
                        <FormattedText value="broker-transferOfDerivativesAvailableBalance" />
                        <OneLineSymbolAmount
                            amountObject={plainAmountDestinationObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountDestinationObject, true)} />
                    </OKInformativeListItem>
                </OKInformativeList>
                {this.buildDerivativeTransferFooterContent()}
            </article>
        )
    }

    buildDerivativeTransferEditFormFooter() {
        const {
            amountToTransfer,
            concept,
            onChangeAmount,
            invalidAmountToTransfer,
            amountToTransferErrorMessage
        } = this.props;

        return (
            <section>
                <h4 className="broker-transfer-of-derivatives__edit-title">
                    <FormattedText value="broker-transferOfDerivativesModifyTitle" />
                </h4>
                <div className="broker-transfer-of-derivatives__edit row">
                    <div className="col-xs-6">
                        <AmountInput
                            label={formatText('broker-transferOfDerivativesModifyAmount')}
                            amount={amountToTransfer}
                            callback={onChangeAmount}
                            error={invalidAmountToTransfer}
                            errorMsg={amountToTransferErrorMessage}
                            language={language}
                        />
                    </div>
                    <div className="col-xs-6">
                        <OKInput
                            label={formatText('broker-transferOfDerivativesModifyConcept')}
                            value={concept}
                            onChange={this.handleConceptChange}
                        />
                    </div>
                </div>
            </section>
        );
    }

    buildDerivativeTransferFooterContent() {
        const {
            editMode,
            amountToTransfer,
            amountToTransferCurrency,
            concept
        } = this.props;

        if (editMode) {
            return this.buildDerivativeTransferEditFormFooter();
        }

        const amountToTransferObject = {
            amount: amountToTransfer,
            currency: amountToTransferCurrency
        };

        const amountToTransferFormat = formatAmountObject(amountToTransferObject);
        const amountToTransferBody =
            `${amountToTransferFormat.amount} ${amountToTransferFormat.currencySymbol}`;

        return (
            <section>
                <OKInformativeList columns={2}>
                    <OKInformativeListItem
                        title="broker-transferOfDerivativesAmountToTransfer"
                        bodyText={amountToTransferBody}
                        isUppercaseTitle={true}
                    />
                    <OKInformativeListItem
                        title="broker-transferOfDerivativesConcept"
                        bodyText={concept || '-'}
                        isUppercaseTitle={true}
                    />
                </OKInformativeList>
            </section>
        );
    }

    buildNoDerivativeTransferContent() {
        return (
            <p><FormattedText value="broker-transferOfDerivativesNone" /></p>
        );
    }

    handleConceptChange(event) {
        this.props.onChangeConcept(event.target.value);
    }

    render() {
        const { isEmpty } = this.props;
        let content;

        if (isEmpty) {
            content = this.buildNoDerivativeTransferContent();
        } else {
            content = this.buildDerivativeTransferContent();
        }

        return (
            <div className="broker-transfer-of-derivatives">
                {content}
            </div>
        );
    }
}

BrokerTransferOfDerivatives.propTypes = {
    isEmpty: PropTypes.bool,
    editMode: PropTypes.bool,
    showCreationDate: PropTypes.bool,
    creationDate: PropTypes.string,
    originAccountName: PropTypes.string,
    originAccountNumber: PropTypes.string,
    originAccountBalance: PropTypes.number,
    originAccountBalanceCurrency: PropTypes.string,
    destinationAccountName: PropTypes.string,
    destinationAccountNumber: PropTypes.string,
    destinationAccountBalance: PropTypes.number,
    destinationAccountBalanceCurrency: PropTypes.string,
    amountToTransfer: PropTypes.number,
    amountToTransferCurrency: PropTypes.string,
    invalidAmountToTransfer: PropTypes.bool,
    amountToTransferErrorMessage: PropTypes.string,
    concept: PropTypes.string,
    onChangeAmount: PropTypes.func,
    onChangeConcept: PropTypes.func,
};

BrokerTransferOfDerivatives.defaultProps = {
    isEmpty: false,
    editMode: false,
    showCreationDate: true,
    invalidAmountToTransfer: false
};

module.exports = BrokerTransferOfDerivatives;
